var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.minutes)+":")]),_c('span',[_vm._v(_vm._s(_vm.seconds < 10 ? '0' + _vm.seconds : _vm.seconds))])])
}
var staticRenderFns = []

export { render, staticRenderFns }